angular.module("AccountingBoxApp").component("companyAutocomplete", {
  templateUrl: "app/components/companyAutocomplete/companyAutocomplete.html",
  controller: companyAutocompleteController,
  bindings: {
    name: "=",
    addresses: "=",
    onCompanySelect: "&",
    onUpdate: "&"
  }
});

function companyAutocompleteController($http) {
  var ctrl = this;

  ctrl.refreshCompaniesList = function(query) {
    if (!query) return;
    if (query.length > 1) {
      return $http
        .get(
          API_ENDPOINT +
            "/Organisations/search?query=" +
            encodeURIComponent(query)
        )
        .then(
          function(response) {
            var companies = [];
            if (response.data.organisations.KvK) {
              response.data.organisations.KvK.forEach(function(company) {
                company.KvK = true;
                companies.push(company);
              });
            }
            const potentialCompanies = (ctrl.addresses || []).map(address => ({
              address: address,
              name: address.addressee,
              tradeName: address.addressee,
            })).filter(company => company.name && company.name.toLowerCase().indexOf(query.toLowerCase()) > -1);

            ctrl.companies = [...companies, ...potentialCompanies];
            return ctrl.companies;
          },
          function(response) {
            console.log("Error loading companies", response);
          }
        );
    }
  };

  ctrl.companySelectHandler = function(company) {
    ctrl.onCompanySelect({ company: company });
    ctrl.getCompanyInfo(company).then(function(company) {
      ctrl.onCompanySelect({ company: company });
    });
  };

  ctrl.getCompanyInfo = function(company) {
    return $http
      .get(
        API_ENDPOINT +
          "/Organisations/kvk/?companyRegistrationNumber=" +
          company.companyRegistrationNumber +
          "&companyName=" +
          company.name
      )
      .then(function(response) {
        return response.data.organisation;
      });
  };
}

angular.module("AccountingBoxApp").directive("typeaheadFocus", function() {
  return {
    require: "ngModel",
    link: function(scope, element, attr, ngModel) {
      //trigger the popup on 'click' because 'focus'
      //is also triggered after the item selection
      element.bind("click", function() {
        var viewValue = ngModel.$viewValue;

        //restore to null value so that the typeahead can detect a change
        if (ngModel.$viewValue == " ") {
          ngModel.$setViewValue(null);
        }

        //force trigger the popup
        ngModel.$setViewValue(" ");

        //set the actual value in case there was already a value in the input
        ngModel.$setViewValue(viewValue || " ");
      });

      //compare function that treats the empty space as a match
      scope.emptyOrMatch = function(actual, expected) {
        if (expected == " ") {
          return true;
        }
        return actual.indexOf(expected) > -1;
      };
    }
  };
});
